import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import axios from "axios";
import { sentryLog } from '../Utils/SentryLog';

function FeedbackPopup({closeFeedbackPopup}){

  const [userRating, setUserRating] = useState(0);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isShowConsole = process.env.NODE_ENV === 'development';

  const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

    useEffect(() => {
        if(statusMessage !== ""){
            setTimeout(() => {
                setStatusMessage("");
                setIsSuccess(false);
            }, 4000);
        }
    }, [statusMessage])

  const handleFeedbackSubmit = async(e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = {
        profession: DOMPurify.sanitize(e.target.profession.value),
        email: DOMPurify.sanitize(e.target.email.value),
        howCanWeImprove: DOMPurify.sanitize(e.target.howCanWeImprove.value),
        rating: userRating,
        extraInfo: e.target.extraInfo.value
    };
    isShowConsole && console.log('feedback form submitted: ', formData);

    try {
        const res = await axios.post(`${API_BASE_URL}/api/feedback`, formData);

        if (res.data.success) {
            setStatusMessage(res.data.message);
            e.target.reset();
            setUserRating(0);
            setIsSuccess(true);
            setIsLoading(false);
            setTimeout(() => {
                closeFeedbackPopup();
            }, 2000);
        } else {
            setStatusMessage(res.data.error || 'Failed to send message.');
            setIsSuccess(false);
            setIsLoading(false);
        }
    } catch (err) {
        isShowConsole && console.error('Error submitting feedback form:', err);
        sentryLog(`FeedbackPopup.js - /api/feedback failed: ${err?.message || err}`);
        setStatusMessage((err.response && err.response.data && err.response.data.error) || "Something went wrong. Please try again later.");
        setIsSuccess(false);
        setIsLoading(false);
    }
  }
  
  return(
    <div className="feedbackOverlay">
      <div className="feedbackPopup">
        <div className="title">
            We would love to hear your feedback!
        </div>
        <div className="closeDiv">
            <button className="closeBtn" onClick={closeFeedbackPopup}>x</button>
        </div>
        <form onSubmit={handleFeedbackSubmit}>
            <div className='feedbackForm'>
                <div className="rating">
                    <label htmlFor="name">Please rate your experience</label>
                    <div className="starDiv">
                        <span onClick={() => setUserRating(5)} className={`five ${userRating >=5 ? 'selected' : ''}`}>★</span>
                        <span onClick={() => setUserRating(4)} className={`four ${userRating >=4 ? 'selected' : ''}`}>★</span>
                        <span onClick={() => setUserRating(3)} className={`three ${userRating >=3 ? 'selected' : ''}`}>★</span>
                        <span onClick={() => setUserRating(2)} className={`two ${userRating >=2 ? 'selected' : ''}`}>★</span>
                        <span onClick={() => setUserRating(1)} className={`one ${userRating >=1 ? 'selected' : ''}`}>★</span>
                        <input
                            key={userRating}
                            type="number"
                            className="hiddenInput"
                            name="ratingHiddenInput"
                            value={userRating === 0 ? '' : userRating}
                            onInvalid={e => e.target.setCustomValidity('Please select a rating')}
                            onInput={e => e.target.setCustomValidity('')}
                            required
                        />    
                    </div>
                </div>
                <div className="profession">
                    <label htmlFor="profession">What best describes you?<br/><span className="hint">(Helps us tailor features for different user needs)</span>
                    </label>
                    <div className="dropdownInput">
                        <select id="profession" name="profession" required>
                            <option className="dropdownOption default" value="">-- Select --</option>
                            <option className="dropdownOption" value="Freelancer">Freelancer</option>
                            <option className="dropdownOption" value="Legal Professional">Legal Professional</option>
                            <option className="dropdownOption" value="Data Entry">Data Entry</option>
                            <option className="dropdownOption" value="Student">Student</option>
                            <option className="dropdownOption" value="Researcher">Researcher</option>
                            <option className="dropdownOption" value="Teacher">Teacher</option>
                            <option className="dropdownOption" value="Journalist">Journalist</option>
                            <option className="dropdownOption" value="Healthcare Professional">Health Care Professional</option>
                            <option className="dropdownOption" value="Software Developer">Software Developer</option>
                            <option className="dropdownOption" value="Corporate / Office Professional">Corporate / Office Professional</option>
                            <option className="dropdownOption" value="Other">Other</option>
                        </select>
                    </div>
                </div>
                <div className="how2imp">
                    <label htmlFor="howCanWeImprove">How can we improve? <span className="optional">(Optional)</span></label><br/>
                    <textarea id="howCanWeImprove" name="howCanWeImprove" rows="2" cols="50"></textarea>
                </div>
                <div className="userEmail">
                    <label htmlFor="email">Premium Features Coming Soon! Get Notified <span className="optional">(Optional)</span></label><br/>
                    <input type="email" id="email" name="email" placeholder="Enter your email" />
                </div>
                <input
                    type="text"
                    name="extraInfo"
                    className="hiddenInput"
                    style={{ display: "none" }}
                    tabIndex="-1"
                    autoComplete="off"
                />
                <div className="submitDiv">
                    <button className="submitBtn" type="submit">
                        Submit
                    </button>
                </div>
            </div>
        </form>
        {statusMessage && 
            <div className='statusMsgCont'>
                <div className={`statusMessage ${isSuccess ? 'success' : 'failure'}`}>{statusMessage}</div>
            </div>
        }
        {isLoading && 
            <div className='loaderDiv'>
                Sending...
            </div>
        }
        </div>
    </div>
  )
}

export default FeedbackPopup;